import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../api/supabase';

export default function MobileQuotations() {
  const navigate = useNavigate();
  const [q, setQ] = useState('');
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    let query = supabase.from('sale_quotations')
      .select('id, quotation_number, title, destination, status, created_at')
      .neq('status', 'VOID')
      .order('created_at', { ascending: false })
      .limit(40);
    if (q) query = query.or(`quotation_number.ilike.%${q}%,title.ilike.%${q}%,destination.ilike.%${q}%`);
    const { data } = await query;
    setRows(data || []);
    setLoading(false);
  }, [q]);

  useEffect(() => { load(); }, [load]);

  return (
    <div style={{ padding: '20px 16px', paddingBottom: 80 }}>
      <div style={{ fontSize: 20, fontWeight: 800, color: '#1a1a2e', marginBottom: 16 }}>Quotations</div>
      <input
        className="form-input"
        placeholder="Search quotation or destination…"
        value={q}
        onChange={e => setQ(e.target.value)}
        style={{ marginBottom: 16, fontSize: 15 }}
      />
      {loading ? (
        <div style={{ textAlign: 'center', padding: 40, color: '#aaa' }}>Loading…</div>
      ) : (
        <div style={{ background: 'white', borderRadius: 12, overflow: 'hidden', boxShadow: '0 1px 6px rgba(0,0,0,0.06)' }}>
          {rows.length === 0 && <div style={{ padding: '24px 16px', color: '#aaa', fontSize: 13, textAlign: 'center' }}>No quotations found</div>}
          {rows.map((r, i) => (
            <div key={r.id} onClick={() => navigate(`/sale-quotations/${r.id}`)}
              style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px', borderBottom: i < rows.length - 1 ? '1px solid #f3f3f3' : 'none', cursor: 'pointer' }}>
              <div>
                <div style={{ fontWeight: 700, fontSize: 14, color: '#c8a96e' }}>{r.quotation_number}</div>
                <div style={{ fontSize: 13, color: '#333', marginTop: 3, fontWeight: 500 }}>{r.title}</div>
                {r.destination && <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>{r.destination}</div>}
              </div>
              <div style={{ textAlign: 'right' }}>
                {r.status === 'SENT' && <div style={{ fontSize: 11, fontWeight: 700, color: '#3b82f6', marginBottom: 4 }}>SENT</div>}
                <div style={{ fontSize: 11, color: '#aaa' }}>{r.created_at?.slice(0, 10)}</div>
                <div style={{ fontSize: 11, color: '#bbb', marginTop: 2 }}>View →</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
